// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorHeader-cls1_X2m","cls2":"AuthorHeader-cls2_zBJ AuthorHeader-cls1_X2m"};